import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';
import { useSession } from 'src/contexts/SessionContext';
import { MeasurementFieldConfig } from 'src/models/measurement/measurement';
import { getSortedMeasurementFieldsForUser } from 'src/models/measurement/utils';

interface MeasurementFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

export const MeasurementFilter: React.FC<MeasurementFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const { session, user, trainer } = useSession();

  const measurementFields = getSortedMeasurementFieldsForUser({
    user,
    trainer,
    session,
  });

  const selectedField = measurementFields.find((f) => f.label === value);

  if (valueOnly) {
    return <>{selectedField?.label || ''}</>;
  }

  return (
    <Autocomplete
      options={measurementFields}
      getOptionLabel={(option: MeasurementFieldConfig) => option.label}
      value={selectedField || null}
      onChange={(_, newValue) => {
        setValue(newValue?.label || '');
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select Measurement" />
      )}
    />
  );
};
